<lex-action-panel>
  <div action-title>Translate</div>
  <div action-body>
    <div style="display: flex; flex-direction: column; flex-wrap: wrap; align-content:center; justify-content: center; height: 150px; gap:20px;">
      <lex-flat-button (click)="openManualTranslationUpload()" [icon]="'fa-duotone fa-upload'" [label]="'Upload Translation'" style="width: 275px;">
      </lex-flat-button>

      <lex-flat-button (click)="deleteTranslation()" [icon]="'fa-duotone fa-trash-can'" [label]="'Remove Translation'"
        [disabled]="(canDeleteTranslation$ | async) === false" style="width: 275px;">
      </lex-flat-button>
    </div>
  </div>
</lex-action-panel>
